import ScoreBar from './ScoreBar.view';

export default ScoreBar;
